import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsRestrictedCheckbox.module.scss';

interface IProps {
	toggleIsRestricted: () => void;
	isRestricted: boolean;
}

export const IsRestrictedCheckbox: React.FC<IProps> = React.memo(({ toggleIsRestricted, isRestricted }) => {
	return (
		<Form.Item className={style.container} name="isRestricted" data-test="IsRestrictedCheckbox">
			<Checkbox onChange={toggleIsRestricted} checked={isRestricted}>
				<Text translationNameSpace="form" translationKey="isRestrictedLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
